import { render, staticRenderFns } from "./TheRecoveryNoticeScreen.vue?vue&type=template&id=f694c30a&"
import script from "./TheRecoveryNoticeScreen.vue?vue&type=script&lang=js&"
export * from "./TheRecoveryNoticeScreen.vue?vue&type=script&lang=js&"
import style0 from "./TheRecoveryNoticeScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports